import React, { SyntheticEvent } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Loader, Container, Grid, Select, DropdownProps, Message } from 'semantic-ui-react';

import { BaseUser } from '../../../src/types';
import usePlant from '../hooks/usePlant';
import PlantSettings from './PlantSettings';
import SensorGraph from './SensorGraph';

const PlantPage = ({ user }: { user: BaseUser | undefined }) => {
    const { id } = useParams<{ id: string }>();
    const { plant, setPlant, readings, fetchReadings, events, fetchEvents, loading, error } = usePlant(id);
    if (loading) {
        return <Loader active />
    }

    if (error) {
        return <Message negative> {error} </Message>
    }

    const onRangeChange = (event: SyntheticEvent<HTMLElement>, { value }: DropdownProps) => {
        fetchReadings(Number(value))
        fetchEvents(Number(value))
    }
    const rangeOptions = [
        {
            text: "24 hours",
            value: 24
        },
        {
            text: "48 hours",
            value: 48
        },
        {
            text: "one week",
            value: 7 * 24
        },
        {
            text: "one month",
            value: 30 * 24
        }
    ]
    return (
        plant
            ?
            <Container>
                <Grid centered>
                    <Grid.Column width={14}>
                        <PlantSettings plant={plant} user={user} setPlant={setPlant} />
                        {readings &&
                            <>
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>
                                            Moisture History
                                        </Card.Header>
                                        <Card.Meta>
                                            Moisture: <span style={{ color: "blue", fontSize:16 }}>
                                                {readings.length > 0 ? `${readings[readings.length - 1]['moisture'].toFixed(2)}%` : 'N/A'}
                                            </span>
                                            <Select
                                                options={rangeOptions}
                                                onChange={onRangeChange}
                                                defaultValue={24}
                                            />
                                        </Card.Meta>
                                        <SensorGraph
                                            readings={readings}
                                            events={events}
                                            dataKey="moisture"
                                            height={300}
                                            minimumTolerance={plant.minimumTolerance}
                                            setPoint={plant.setPoint}
                                        />
                                    </Card.Content>
                                </Card>
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>
                                            Raw Sensor History
                                        </Card.Header>
                                        <Card.Meta>
                                            Raw Value: <span style={{ color: "blue" }}> 
                                                {readings.length > 0 ? readings[readings.length - 1]['rawValue'] : 'N/A'}
                                            </span>
                                        </Card.Meta>
                                        <SensorGraph
                                            events={events}
                                            readings={readings}
                                            dataKey="rawValue"
                                            height={300}
                                        />
                                    </Card.Content>
                                </Card>
                            </>
                        }
                    </Grid.Column>
                </Grid>
            </Container>
            : <Loader />
    )
}

export default PlantPage;